import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const navLinks = [
  { label: "Features", href: "#features" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      data-testid="navigation"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/90 backdrop-blur-md border-b border-gray-200 shadow-sm"
          : "bg-white border-b border-transparent"
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
        <a href="#hero" data-testid="nav-logo" className="flex items-center gap-3">
          <img
            src="https://customer-assets.emergentagent.com/job_veltech-ghana-demo/artifacts/l9uedkjb_Veltech%20Logo%201.2%20For%20Head%20Navigation.png"
            alt="VelTech Ghana"
            className="w-10 h-10 object-contain"
          />
          <span
            className="text-lg font-black text-[#0A0A0A] tracking-tight"
            style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
          >
            Veltechgh
          </span>
        </a>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              data-testid={`nav-link-${link.label.toLowerCase()}`}
              className="text-sm text-gray-500 hover:text-[#0A0A0A] transition-colors font-bold tracking-wide uppercase"
              style={{ fontFamily: "'Satoshi', sans-serif" }}
            >
              {link.label}
            </a>
          ))}
        </div>

        <a
          href="#contact"
          data-testid="nav-cta-contact"
          className="hidden md:inline-flex bg-[#0A0A0A] hover:bg-[#1a1a1a] text-white font-black px-7 py-3 text-sm uppercase tracking-wider transition-all duration-200"
          style={{ fontFamily: "'Satoshi', sans-serif" }}
        >
          Request Proposal
        </a>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-[#0A0A0A] p-2"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          {mobileOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {mobileOpen && (
        <div data-testid="nav-mobile-menu" className="md:hidden bg-white border-t border-gray-100 px-6 py-6 space-y-4">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              data-testid={`nav-mobile-link-${link.label.toLowerCase()}`}
              className="block text-base text-gray-600 hover:text-[#0A0A0A] transition-colors uppercase tracking-wide font-bold"
              onClick={() => setMobileOpen(false)}
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contact"
            data-testid="nav-mobile-cta"
            className="block w-full text-center bg-[#0A0A0A] text-white font-black py-3 uppercase tracking-wider mt-4"
            onClick={() => setMobileOpen(false)}
          >
            Request Proposal
          </a>
        </div>
      )}
    </nav>
  );
}
